import { GridItemMain } from '@components/GridItem/index.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import { TextBody, Heading4Serif } from '@styles/vars/textStyles.style'
import styled from 'styled-components'
import { clamp } from '@styles/utils/conversion.style'

export const HighlightsMain = styled.section`
  color: ${colors.white};
  background-color: ${colors.charcoal};

  ${mq.tabletL} {
    ${GridItemMain} {
      position: relative;

      &:nth-child(n + 4) {
        margin-top: 5.1rem;
      }

      &:nth-child(2) {
        &:before {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          transform-origin: 0% 50%;
          transform: scaleX(3);
          display: block;
          width: 100%;
          height: 0.1rem;
          background-color: ${colors.mist};
          opacity: 0.2;
        }
      }
    }
  }

  .gatsby-image-wrapper {
    ${mq.tabletLMax} {
      width: 50%;
    }
  }

  ${TextBody} {
    padding-right: 1rem;
    ${clamp('font-size', 16, 22)};
    line-height: 1.2;
  }
  ${Heading4Serif} {
    ${clamp('font-size', 19, 26)};
    line-height: 1.2;
  }
`

export const Highlight = styled.div`
  color: ${colors.pastelOcean};
  .gatsby-image-wrapper {
    max-width: 120px;
  }
`
